import { DOCUMENT_LIKE_FILE_TYPES_QUERY } from '../../utils/fileTypes';

/*
Filters definition:

* value: A string identifier for the filter.
* label: The value to be displayed as an option in the type of filter select.
* type: "text" or "select" for the type of component to be rendered as the value input.
* query: The query used by widen for the filter.
* hide: If the filter type should be hidden or not.
* options: If the filter has multiple selection options, they should be included here.
    options.value: The value of the option.
    options.label: The label that should be displayed for the option.
* placeholder: The placeholder for the input component.
*/

export const getFilters = prefilters => [{
  value: "file-name",
  label: "File Name",
  type: "text",
  query: "fn",
  placeholder: "Search for file name"
}, {
  value: "file-type",
  label: "File Type",
  type: "select",
  query: "ft",
  hide: !!prefilters.find(({
    filterType
  }) => filterType === "file-type"),
  options: [{
    value: DOCUMENT_LIKE_FILE_TYPES_QUERY,
    label: "Document/Office/Archive"
  }, {
    value: "audio",
    label: "Audio"
  }, {
    value: "video",
    label: "Video"
  }, {
    value: "image",
    label: "Image"
  }]
}, {
  value: "display-title",
  label: "Display Title",
  type: "text",
  query: "dn",
  placeholder: "Search for display title"
}, {
  value: "topic-uuid",
  label: "Topic Uuid",
  type: "text",
  query: "tu",
  placeholder: "Search for Uuid"
}, {
  value: "alt-text",
  label: "Alt Text",
  type: "text",
  query: "at2",
  placeholder: "Search for alt text"
}].filter(({
  hide
}) => !hide);